import React from 'react';
import { compose, prop } from 'ramda';
import { Control } from '../Control';
import withField from '../withField';
import { useAppSelector } from 'js/store/hooks';

import * as hoc from './hoc';
import * as constants from './constants';
import { Picker } from './components/Picker';

import style from './DatePicker.scss';

/**
 * @typedef {"PAST" | "FUTURE" | string} DatePickerRange

 * @param props {Object}
 * @param [props.input] {Object}
 * @param [props.meta] {Object}
 * @param [props.id] {string}
 * @param [props.label] {string}
 * @param [props.readOnly] {boolean}
 * @param [props.className] {string}
 * @param [props.classNames] {Object}
 * @param [props.disabled] {boolean}
 * @param [props.isPickersSeparate] {boolean}
 * @param [props.range] {DatePickerRange} One of predefined value "PAST" (default) or "FUTURE" or custom range "<from>-<to>"
 * @example range={"1999-2030"}
 */
export const DatePickerDumb = ({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    id,
    label,
    parse,
    setValue,
    readOnly,
    className,
    classNames,
    infoTooltip,
    disabled = false,
    isLabelAsteriskEnabled,
    isPickersSeparate = true,
    range = constants.RANGE.PAST
}) => {
    const dateFormat = useAppSelector(prop('dateFormat'));
    const dateParts = dateFormat.split(/[-/]/);

    return (
        <Control
            id={id}
            meta={meta}
            label={label}
            animate={true}
            readOnly={readOnly}
            disabled={disabled}
            className={className}
            classNames={classNames}
            infoTooltip={infoTooltip}
            isBorderHidden={isPickersSeparate}
            isLabelAsteriskEnabled={isLabelAsteriskEnabled}
        >
            <div className={style.container}>
                {
                    dateParts.map((datePart) => {
                        switch (datePart) {
                            case constants.DATE_PART.year:
                                return (
                                    <Picker
                                        range={range}
                                        parse={parse}
                                        key={datePart}
                                        setValue={setValue}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        type={constants.PICKERS.year}
                                        isBorderShown={isPickersSeparate}
                                        {...input}
                                    />
                                );
                            case constants.DATE_PART.month:
                                return (
                                    <Picker
                                        parse={parse}
                                        key={datePart}
                                        setValue={setValue}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        type={constants.PICKERS.month}
                                        isBorderShown={isPickersSeparate}
                                        {...input}
                                    />
                                );
                            case constants.DATE_PART.day:
                                return (
                                    <Picker
                                        parse={parse}
                                        key={datePart}
                                        setValue={setValue}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        type={constants.PICKERS.day}
                                        isBorderShown={isPickersSeparate}
                                        {...input}
                                    />
                                );
                            default:
                                return null;
                        }
                    })
                }
            </div>
        </Control>
    );
};

export const enhance = compose(
    hoc.withFieldProps,
    withField
);

export const DatePicker = enhance(DatePickerDumb);
